import React from 'react'
import useCreatePaymentMethod from '../../common/hooks/useCreatePaymentMethod'
import { type WebCustomer2, type WebPaymentMethod2 } from '../../common/types/webshop.types';
import PaymentMethodForm, { type PaymentMethodFormData } from '../../common/components/payment-method-new/PaymentMethodForm';
import { fetchCard } from '../../common/js/bfx-customer-utility';
import { type RecurringRepairSubscription } from '../types/recurring-repair.types';
import { axiosPost } from '../../common/js/axios-utility';
import { errorToast } from '../../common/js/toast-utility';

type Props = {
    customer: WebCustomer2,
    subscription: RecurringRepairSubscription,
    onComplete: () => void
}

export default function Billing({customer, subscription, onComplete}: Props) {
    const {saveCard} = useCreatePaymentMethod();
    
    const handleSubmit = async (payload: PaymentMethodFormData) => {
        try{
        //this.submitting = true;
        let card: WebPaymentMethod2;
        if (payload.isNewCard){
            card = await saveCard(payload, customer);
        }
        else{
            card = fetchCard(payload.selectedId, customer);
        }

        const submitPayload = {
            subscription: subscription,
            paymentMethodId: card.id
        }
            const {data} = await axiosPost('/subscription/repair', submitPayload);
            onComplete();
        }
        catch(err){
            errorToast('Failed to update subscription.');
        }
    }
        
    return (
        <div>
            <PaymentMethodForm customer={customer} onSubmit={handleSubmit} />
        </div>
    )
}